import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";

export function setStatusBarAsBlackOnWhite() {
  if (!Capacitor.isPluginAvailable("StatusBar")) {
    return;
  }

  if (Capacitor.getPlatform() === "android") {
    StatusBar.setOverlaysWebView({ overlay: false });
    StatusBar.setBackgroundColor({ color: "#FFFFFF" });
    StatusBar.setStyle({ style: Style.Light });
  }

  if (Capacitor.getPlatform() === "ios") {
    StatusBar.setStyle({ style: Style.Light });
  }
}

export function setStatusBarTranslucent() {
  if (!Capacitor.isPluginAvailable("StatusBar")) {
    return;
  }

  if (Capacitor.getPlatform() === "android") {
    StatusBar.setOverlaysWebView({ overlay: false });
    StatusBar.setStyle({ style: Style.Light });
    StatusBar.setBackgroundColor({ color: "#121212" });
  }

  if (Capacitor.getPlatform() === "ios") {
    StatusBar.setStyle({ style: Style.Default });
  }
}

export function setStatusBarAsOverlayWhite() {
  if (!Capacitor.isPluginAvailable("StatusBar")) {
    return;
  }

  if (Capacitor.getPlatform() === "android") {
    StatusBar.setOverlaysWebView({ overlay: true });
  }

  StatusBar.setStyle({ style: Style.Dark });
}
